"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NemethProjectUser = exports.NemethProjectPath = exports.NemethProjectDocuments = exports.FeedbackStatus = exports.Interaction = exports.TestsCollection = exports.NemethCollection = exports.NemethProject = exports.NemethUrl = void 0;
exports.NemethUrl = 'https://nemeth-project.firebaseio.com';
exports.NemethProject = 'nemeth-project';
exports.NemethCollection = 'nemeth';
exports.TestsCollection = 'tests';
exports.Interaction = 'InteractionStatus';
exports.FeedbackStatus = 'feedback';
exports.NemethProjectDocuments = exports.NemethProject + '::documents';
exports.NemethProjectPath = exports.NemethProject + '::path';
exports.NemethProjectUser = exports.NemethProject + '::user';
